<div class="admin-dashboard">
  <div class="dashboard-header">
    <div class="header-content">
      <div class="welcome-section">
        <h1 class="dashboard-title">Club Management</h1>
        <p class="dashboard-subtitle">Welcome to your admin dashboard</p>
      </div>
      <div class="header-actions">
        <div class="admin-badge">
          <div class="badge-icon">
            <lucide-icon name="crown" [size]="16"></lucide-icon>
          </div>
          <span class="badge-text">Admin</span>
        </div>
        <button class="logout-button" (click)="logout()">
          <div class="logout-icon">
            <lucide-icon name="log-out" [size]="16"></lucide-icon>
          </div>
          <span class="logout-text">Logout</span>
        </button>
      </div>
    </div>
  </div>

  <div class="dashboard-content" *ngIf="!isLoading; else loading">
    <div class="management-grid">
      <div class="management-card" (click)="goToCourtBookings()">
        <div class="card-header">
          <div class="card-icon">
            <lucide-icon name="landmark" [size]="24"></lucide-icon>
          </div>
          <div class="card-badge">Active</div>
        </div>
        <div class="card-content">
          <h3 class="card-title">Court Bookings</h3>
          <p class="card-description">View and manage all court reservations</p>
        </div>
        <div class="card-footer">
          <span class="action-text">Manage Bookings</span>
          <div class="arrow-icon">→</div>
        </div>
      </div>

      <div class="management-card" (click)="goToManualBook()">
        <div class="card-header">
          <div class="card-icon">
            <lucide-icon name="phone" [size]="24"></lucide-icon>
          </div>
          <div class="card-badge">Quick</div>
        </div>
        <div class="card-content">
          <h3 class="card-title">Phone Booking</h3>
          <p class="card-description">Add reservations from phone calls</p>
        </div>
        <div class="card-footer">
          <span class="action-text">Add Booking</span>
          <div class="arrow-icon">→</div>
        </div>
      </div>

      <div class="management-card" (click)="goToFixedBooking()">
        <div class="card-header">
          <div class="card-icon">
            <lucide-icon name="calendar" [size]="24"></lucide-icon>
          </div>
          <div class="card-badge">Recurring</div>
        </div>
        <div class="card-content">
          <h3 class="card-title">Fixed Reservations</h3>
          <p class="card-description">Manage recurring court bookings</p>
        </div>
        <div class="card-footer">
          <span class="action-text">View Fixed</span>
          <div class="arrow-icon">→</div>
        </div>
      </div>

      <div class="management-card" (click)="goToApproveUsers()">
        <div class="card-header">
          <div class="card-icon">
            <lucide-icon name="users" [size]="24"></lucide-icon>
          </div>
          <div class="card-badge">Pending</div>
        </div>
        <div class="card-content">
          <h3 class="card-title">User Approvals</h3>
          <p class="card-description">Review and approve new members</p>
        </div>
        <div class="card-footer">
          <span class="action-text">Review Users</span>
          <div class="arrow-icon">→</div>
        </div>
      </div>

      <div class="management-card" (click)="goToApproveMatches()">
        <div class="card-header">
          <div class="card-icon">
            <lucide-icon name="circle-check" [size]="24"></lucide-icon>
          </div>
          <div class="card-badge">Review</div>
        </div>
        <div class="card-content">
          <h3 class="card-title">Match Approvals</h3>
          <p class="card-description">Approve match requests and disputes</p>
        </div>
        <div class="card-footer">
          <span class="action-text">Review Matches</span>
          <div class="arrow-icon">→</div>
        </div>
      </div>

      <div class="management-card" (click)="goToAnalytics()">
        <div class="card-header">
          <div class="card-icon">
            <lucide-icon name="bar-chart-3" [size]="24"></lucide-icon>
          </div>
          <div class="card-badge">Insights</div>
        </div>
        <div class="card-content">
          <h3 class="card-title">Analytics</h3>
          <p class="card-description">View club performance and statistics</p>
        </div>
        <div class="card-footer">
          <span class="action-text">View Reports</span>
          <div class="arrow-icon">→</div>
        </div>
      </div>

      <div class="management-card" (click)="goToTournaments()">
        <div class="card-header">
          <div class="card-icon">
            <lucide-icon name="trophy" [size]="24"></lucide-icon>
          </div>
          <div class="card-badge">Events</div>
        </div>
        <div class="card-content">
          <h3 class="card-title">Tournaments</h3>
          <p class="card-description">Create and manage club tournaments</p>
        </div>
        <div class="card-footer">
          <span class="action-text">Manage Tournaments</span>
          <div class="arrow-icon">→</div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p class="loading-text">Loading dashboard...</p>
  </div>
</ng-template>
